<bzg-modal-header>
  <span class="bzg-modal__header">{{data.title}}</span>
</bzg-modal-header>
<bzg-modal-content>
  <p class="justify-text" [innerHTML]="data.message"></p>
</bzg-modal-content>
<bzg-modal-footer>
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m">{{'GLOBAL.CANCEL' | translate}}
  </bzg-button-secondary>
  <bzg-button-primary (click)="ok()">{{data.button}}
  </bzg-button-primary>
</bzg-modal-footer>